"use client";

import React, { useEffect, useRef, useState } from "react";

type MinorSkill = {
  minorSkillName: string;
  minorSkillLevel: number;
};

type SkillProps = {
  skillProps: {
    skillName: string;
    skillDescription: string;
    skillSetBars: Array<MinorSkill>;
  };
};

export function SkillSetBars({ skillProps }: SkillProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="flex-1 flex flex-col gap-5 p-10 rounded-lg bg-secondary-grey min-w-xs"
    >
      <div className="flex flex-col flex-nowrap">
        <h2>{skillProps.skillName}</h2>
        <p>{skillProps.skillDescription}</p>
      </div>

      <ul className="flex flex-col gap-5">
        {skillProps.skillSetBars.map((skill, index) => (
          <li key={index} className="flex flex-col w-full gap-1">
            <div className="flex justify-between items-center">
              <span className="text-white text-sm">{skill.minorSkillName}</span>
              <span className="text-primary-yellow text-sm">
                {skill.minorSkillLevel}/5
              </span>
            </div>

            <div className="w-full h-2 bg-background-grey rounded-full overflow-hidden">
              <div
                className={`h-full bg-primary-yellow transition-all duration-1000 ease-in-out`}
                style={{
                  width: inView
                    ? `${(skill.minorSkillLevel / 5) * 100}%`
                    : `0%`,
                }}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
